export const lerp = (v0: number, v1: number, t: number) => v0 * (1 - t) + v1 * t
